module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Tresa_COA-d9b5bcba2f1d7befdd0e705365d34669.svg";